import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import Loader from 'components/layout/Loader';
import TableResponsive from 'components/layout/TableResponsive';
import _ from 'lodash';
import IntlDateTime from '../IntlDateTime';


class ProvisionServiceList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedProvisionService: null,
    };
  }

  translateTitle = i => {
    const index = _.findIndex(this.props.list[i].title, title => title.lang === this.props.appIntl.locale);
    return this.props.list[i].title[index].name;
  };

  translateDescription = i => {
    const index = _.findIndex(this.props.list[i].description, title => title.lang === this.props.appIntl.locale);
    return this.props.list[i].description[index].description;
  };

  render() {
    const {
      intl: { messages },
      list,
      listName,
      inModal,
      user,
    } = this.props;

    /* Todo */
    const headers = {
      serviceType: messages.provision_service_documents_serviceType,
      title: messages.provision_service_title,
      description: messages.provision_service_description,
      client: messages.provision_service_documents_Client,
      provisionPayedDate: messages.provision_service_documents_provisionPayedDate,
      provisionRate: messages.provision_service_documents_provisionRate,
      provisionValue: messages.provision_service_documents_provisionValue
    };

    /* Todo */
    const rows = [];
    for (let i = 0; i < list.length; i++) {
      const position = list[i];
      const {
        number,
        name,
        description,
        number_prefix: numberPrefix,
        sum_gross: sumGross,
        currency,
        cdate,
      } = position;

      const rowData = {
        serviceType: position?.service_type?.name,
        title: this.translateDescription(i),
        description: this.translateDescription(i),
        client: position?.client?.username,
        provisionPayedDate: <IntlDateTime date={position?.payed_date} />,
        provisionRate: position?.provision_rate,
        provisionValue: position?.provision_value
      };

      rows.push(rowData);
    }

    return list.pending ? (
      <Loader />
    ) : (
      <>
        <TableResponsive headers={headers} rows={rows} hover />
      </>
    );
  }
}

ProvisionServiceList.defaultProps = {
  inModal: false,
  showDetailsAction: null,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
  };
};

const mapDispatchToProps = dispatch => {
  return{
  }
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ProvisionServiceList)
  )
);
